/* ── Reports (IncomeBazaar redesign) ── */
.reports {
  max-width: 1240px;
  margin: 0 auto;
  padding: 22px 24px 40px;
}

/* Page head: back arrow + serif title */
.pagehead {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 16px;
}

.backBtn {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: grid;
  place-items: center;
  color: var(--ib-ink);
  font-size: 1rem;
}

.backBtn:hover {
  background: var(--ib-line-2);
}

.pageTitle {
  font-family: var(--font-serif);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ib-ink);
}

/* ── White panel holding the report rows ── */
.panel {
  background: var(--ib-panel);
  border: 1px solid var(--ib-line);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(27, 37, 52, 0.05), 0 6px 18px rgba(120, 30, 30, 0.05);
  overflow: hidden;
}

/* ── Report row / tile ── */
.tile {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px;
}

.tile + .tile,
.gstBlock {
  border-top: 1px solid var(--ib-line-2);
}

.tileText {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.tileTitle {
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ib-ink);
}

.tileDesc {
  line-height: 1.4;
}

.note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  color: var(--ib-faint);
}

.note ion-icon {
  font-size: 0.95rem;
  margin-top: 1px;
  flex: none;
}

/* Right-hand action cluster */
.tileAction {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  flex: none;
}

/* The blue "Download" text-buttons become red text-buttons.
   Compound selector (.tileAction .downloadBtn) outranks Button's .buttonText. */
.tileAction .downloadBtn {
  color: var(--ib-red);
  font-weight: 700;
  font-size: 0.9rem;
  padding: 6px 12px;
  border-radius: 8px;
  align-self: auto;
  transition: background 0.15s ease, color 0.15s ease;
}

.tileAction .downloadBtn:hover {
  background: var(--ib-red-soft);
  color: var(--ib-red-d);
}

.tileAction .downloadBtn:disabled {
  color: var(--ib-faint);
  cursor: not-allowed;
  background: 0;
}

/* ── Inputs (date + GST search) — token borders, red focus ── */
.dateInput {
  width: 180px;
  max-width: 100%;
}

.dateInput input,
.searchInput input {
  border: 1px solid var(--ib-line);
  border-radius: 8px;
  padding: 0.5rem 0.7rem;
  font-size: 0.9rem;
  color: var(--ib-ink);
  background: var(--ib-panel);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.dateInput input:focus,
.searchInput input:focus {
  border: 1px solid var(--ib-red);
  box-shadow: 0 0 0 3px var(--ib-red-soft);
}

/* ── GST invoices block ── */
.gstBlock {
  padding: 18px 22px;
}

.gstHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.searchInput {
  width: 240px;
  max-width: 45%;
  flex: none;
}

.invoicesList {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-top: 1.25rem;
  font-variant-numeric: tabular-nums lining-nums;
}

@media only screen and (max-width: 560px) {
  .reports {
    padding: 16px 14px 32px;
  }

  .tile,
  .gstHead {
    flex-direction: column;
    align-items: stretch;
  }

  .tileAction {
    align-items: flex-start;
  }

  .searchInput {
    width: 100%;
    max-width: 100%;
    margin-top: 12px;
  }
}
